angular.module('unergie.main')
.directive('newJiraIssue', ($location, AdminComments, AlertManager, ApiAdmin, ErrorCatcher, JiraConstants, JiraService) =>
  ({
      restrict: 'E',
      templateUrl: '/directives/new-jira-issue/new-jira-issue.html',
      link($scope) {
          JiraService.getEpics().then((epics) => {
              $scope.epics = epics
          })

          $scope.initJiraData = () => {
              $scope.newJiraIssue = JiraService.init($scope.epics)
          }

          $scope.confirmJiraIssueSubmit = () => {
              const epicLink = $scope.newJiraIssue.template.epic.key
              const epicData = $scope.newJiraIssue.template.epic
              const projectKey = epicData ? epicData.fields.project.key : 'exploit'
              const jiraIssue = {
                  summary: $scope.newJiraIssue.template.summary,
                  description: `${$scope.newJiraIssue.template.description}\n\n----\n\n${$location.absUrl()}`,
                  type: $scope.newJiraIssue.template.issuetype,
                  epicLink,
                  priority: $scope.newJiraIssue.template.priority,
                  enrichSummary: false,
                  idCase: $scope.newJiraIssue.template.idCase,
                  reminder: $scope.newJiraIssue.fields.reminder.hidden($scope.newJiraIssue.template) ? $scope.newJiraIssue.template.reminderCustomerCallback : $scope.newJiraIssue.template.reminder,
                  sensitive: $scope.newJiraIssue.template.sensitive,
                  selfAssign: $scope.newJiraIssue.template.selfAssign,
              }

              return ApiAdmin.createJiraIssue({ projectKey }, jiraIssue).$promise.then(() => {
                  // Save data
                  AlertManager.success('Issue JIRA créée')
              })
              .catch(ErrorCatcher)
          }
      },
  })
)
